<template>
  <div>

  </div>
</template>
<script>
export default {
  created() {
    this.$store.dispatch('emailCampaignCart/reset');
    this.$router.replace({name: `${this.$root.routePrefix}.mailcoach.campaign.wizard.template`, query: this.$route.query});
  }
}
</script>
